import React, { lazy, Suspense, memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { ConfigProvider } from 'antd';
import Loading from 'components/shared-components/Loading';
import { lightTheme, darkTheme } from 'configs/ThemeConfig';
import { resources } from 'lang';
import useBodyClass from 'utils/hooks/useBodyClass';
import Routes from 'routes'
import OfferLandingPage from "components/offerLandingPage";
import axios from 'axios';
import { env } from 'configs/EnvironmentConfig';
import ApiConfig from 'configs/ApiConfig';

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {
	  const [showOfferModal, setShowOfferModal] = useState(false);


	//const token = useSelector(state => state.auth.token);
	//const blankLayout = useSelector(state => state.theme.blankLayout);
	//todo config auth entry *token && !blankLayout ? AppLayout : AuthLayout;" " which would use different container for unathenticated routes
	const Layout = true ? AppLayout : AuthLayout;

	const locale = useSelector(state => state.theme.locale);

	const direction = useSelector(state => state.theme.direction);

	const currentTheme = useSelector(state => state.theme.currentTheme);

	const currentAppLocale = resources[locale];

	useBodyClass(`dir-${direction}`);

	const themeConfig = currentTheme === 'light' ? {...lightTheme} : {...darkTheme}

	
  const [accountSettings,setsettings]=useState({})
  console.log(accountSettings,'accountSettingsaccountSettings')

const getaccountsettings = async () => {
    try {
      const response = await axios.get(`${env?.API_ENDPOINT_URL}/${ApiConfig.website.getaccountsettings}`);
      setsettings(response?.data?.[0])
      // form.setFieldsValue({homepage:response?.data?.[0]?.homepage,
      //   home:response?.data?.[0]?.hiddenmenu?.includes("/home"),
      //   rule:response?.data?.[0]?.hiddenmenu?.includes("/rule"),
      //   portal:response?.data?.[0]?.portal,
      //   rulelink:response?.data?.[0]?.rule
      // })
    } catch (error) {
      return [];
    }
  }
  useEffect(()=>{
	getaccountsettings()
  },[])

useEffect(() => {
    if (
      //accountSettings?.status === "succeeded" && 
      accountSettings?.offer_landing_page?.enabled &&
      accountSettings?.offer_landing_page?.title &&
      accountSettings?.offer_landing_page?.body
    ) {
      // Check if modal was already dismissed in this session
      const modalDismissed = sessionStorage.getItem('offerModalDismissed');
      console.log(modalDismissed,'modalDismissed')
      if (!modalDismissed) {
        setShowOfferModal(true);
      }
    }
  }, [accountSettings]);
  console.log(accountSettings,'accountSettingslog')

  const handleCloseOfferModal = () => {
    setShowOfferModal(false);
    // Remember that the modal was dismissed for this session
    sessionStorage.setItem('offerModalDismissed', 'true');
  };
  const imgurl = process.env.REACT_APP_DEV_API_REDIRECT_URL.includes("tcbl")
      ? "https://leaguepro.s3.ca-central-1.amazonaws.com"
      : "https://leaguepro.s3.ca-central-1.amazonaws.com";

	return (
		<ConfigProvider theme={themeConfig} direction={direction} locale={currentAppLocale.antd}>
			<Suspense fallback={<Loading cover="content"/>}>
				<Layout>
					<Routes />
				</Layout>
				
      {showOfferModal && accountSettings?.offer_landing_page && (
        <OfferLandingPage
          title={accountSettings.offer_landing_page.title}
          body={accountSettings.offer_landing_page.body}
          backgroundImage={accountSettings.offer_landing_page.background_image ? `${imgurl}${accountSettings.offer_landing_page.background_image}` : undefined}
          actionButton={accountSettings.offer_landing_page.action_button}
          themeColors={accountSettings.theme_colors}
          isModal={true}
          onClose={handleCloseOfferModal}
        />
      )}
			</Suspense>
		</ConfigProvider>
	)
}

export default memo(Layouts)